/* eslint-disable react/no-danger */
import React from 'react'

import { getClientConfig } from '@Globals/Config'

// Used as a fallback when javascript is disabled
const gtmFallback = (googleTagManagerKey: string) => `
<iframe src="/sth/ns.html?id=${googleTagManagerKey}"
height="0" width="0" style="display:none;visibility:hidden"></iframe>
`

export const gtmInit = (googleTagManagerKey: string) => `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'/sth/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${googleTagManagerKey}');
`

// Rendered by _document, outside every provider, so it reads the config directly (server side only)
export const GTMNoScript = () => (
  <noscript
    key="gtm-no-script"
    dangerouslySetInnerHTML={{ __html: gtmFallback(getClientConfig().googleTagManagerKey) }}
  />
)
